import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick-circled",
  "use": "tick-circled-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"tick-circled\"><path d=\"M12.26 2.14a10.55 10.55 0 0 1 0 21.08A10.55 10.55 0 0 1 1.72 12.68c0-5.8 4.73-10.54 10.54-10.54Zm0-1.71a12.26 12.26 0 1 0 0 24.52 12.26 12.26 0 0 0 0-24.52Z\" /><path d=\"m18.46 9.2-8.14 8.14a.87.87 0 0 1-.64.24.9.9 0 0 1-.64-.24l-2.99-3a.84.84 0 0 1 0-1.17.8.8 0 0 1 .6-.24c.21 0 .43.07.58.24l2.45 2.45 7.6-7.6a.8.8 0 0 1 .59-.24c.22 0 .44.07.59.24.31.32.31.86 0 1.18Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol